import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { useIntl } from "@edx/frontend-platform/i18n";

import { FormGroup } from "../../../common-components";
import { clearRegistrationBackendError } from "../../data/actions";

import { validateCompany } from "./extraValidator";

const CompanyField = (props) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  const { handleErrorChange } = props;

  const handleOnBlur = (e) => {
    const { value } = e.target;
    const fieldError = validateCompany(value, formatMessage);
    handleErrorChange("company", fieldError);
  };

  const handleOnFocus = () => {
    handleErrorChange("company", "");
    dispatch(clearRegistrationBackendError("company"));
  };

  return (
    <FormGroup
      {...props}
      handleBlur={handleOnBlur}
      handleFocus={handleOnFocus}
    />
  );
};

CompanyField.defaultProps = {
  errorMessage: "",
};

CompanyField.propTypes = {
  errorMessage: PropTypes.string,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
};

export default CompanyField;
